import {
	SIGNOUT_USER,
	SET_ADMIN_FEEDBACK,
	SERVER_GET_ADMIN_FEEDBACK_CHAT,
	SET_ADMIN_FEEDBACK_CHAT,
	SERVER_SEND_FEEDBACK_MESSAGE
} from 'constants/ActionTypes';
import Moment from 'moment';

const INITIAL_STATE = {
	feedback: [],
	activeChat: [],
	activeFeedback: null,
	appUserData: {},
	appUserReports: [],
	loading: {
		chat: false
	}
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SIGNOUT_USER:
			return INITIAL_STATE;
		case SET_ADMIN_FEEDBACK:
			return { ...state, feedback: action.payload.feedback };
		case SERVER_GET_ADMIN_FEEDBACK_CHAT:
			return {
				...state,
				activeChat: INITIAL_STATE.activeChat,
				activeFeedback: action.payload.feedback,
				loading: { ...state.loading, chat: true }
			};
		case SET_ADMIN_FEEDBACK_CHAT:
			return {
				...state,
				activeChat: action.payload.chat,
				appUserData: action.payload.appUserData,
				appUserReports: action.payload.appUserReports,
				loading: { ...state.loading, chat: false }
			};
		case SERVER_SEND_FEEDBACK_MESSAGE:
			return {
				...state,
				activeChat: [
					...state.activeChat,
					{
						type: 'sent',
						message: action.payload.message,
						sentAt: Moment().format('DD.MM.YYYY HH:mm')
					}
				]
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./reducers/AdminFeedback.js